import {
  AddNodeToolUI,
  RemoveNodeToolUI,
  UpdateNodeToolUI,
  ConnectNodesToolUI,
  RemoveEdgeToolUI,
  RunPipelineToolUI,
  BuildPipelineToolUI,
} from "./WriteToolUIs";
import {
  GetPipelineToolUI,
  GetAvailableModulesToolUI,
  GetNodeToolUI,
  GetNodeOutputToolUI,
} from "./ReadToolUIs";

/**
 * Renders null — exists only to register all pipeline tool UIs via useAssistantToolUI.
 * Must be rendered inside an AssistantRuntimeProvider.
 */
export function PipelineToolUIs() {
  return (
    <>
      <AddNodeToolUI />
      <RemoveNodeToolUI />
      <UpdateNodeToolUI />
      <ConnectNodesToolUI />
      <RemoveEdgeToolUI />
      <RunPipelineToolUI />
      <BuildPipelineToolUI />
      <GetPipelineToolUI />
      <GetAvailableModulesToolUI />
      <GetNodeToolUI />
      <GetNodeOutputToolUI />
    </>
  );
}
